import { MuiThemeProvider, createTheme } from '@material-ui/core/styles';
import { KeycloakProvider } from '@react-keycloak/web';
import { Provider } from 'mobx-react';
import moment from 'moment';
import React from 'react';
import CustomSnackbarProvider from './components/CustomSnackbarProvider';
import EndingDialog, { EndingDialogProvider } from './components/EndingDialog';
import { LoadingProvider } from './components/Loading';
import MainApp from './components/MainApp';
import DatePickedProvider from './components/inputs/DatePickerProvider';

import { LayoutProvider } from './context/LayoutContext';
import keycloak, { onAuthSuccess } from './keycloak';
import stores from './stores';
import './utils/i18n';

moment.locale('es');

// eslint-disable-next-line prefer-const
let silentCheckSsoRedirectUri = `${window.location.origin}${
  process.env.PUBLIC_URL ? `${process.env.PUBLIC_URL}/` : '/'
}silent-check-sso.html`;

const keycloakProviderInitConfig = {
  onLoad: 'check-sso',
  silentCheckSsoRedirectUri,
  checkLoginIframe: false // descomentar si se usa chrome o navegador basado en chromium
};

const theme = createTheme({
  palette: {
    primary: { main: '#2d385f' },
    secondary: { main: '#2d385f' },
    error: { main: '#F44336' },
    danger: { main: '#F44336' }
  },
  overrides: {
    MuiFilledInput: {
      root: {
        backgroundColor: 'rgba(0,0,0,0.03)'
      }
    }
    // MuiOutlinedInput: {
    //   root: {
    //     fontSize: '20px'
    //   },
    //   input: {
    //     padding: '18.5px 14px',
    //     height: 56,
    //     boxSizing: 'border-box'
    //   }
    // },
    // MuiInputLabel: {
    //   root: {
    //     fontSize: '20px'
    //   },
    //   outlined: {
    //     transform: 'translate(14px, 19px) scale(1)'
    //   }
    // }
  },
  typography: {}
});
// theme.typography.h4 = {
//   fontSize: '1.2rem',
//   [theme.breakpoints.up('md')]: {
//     fontSize: '2.2rem'
//   }
// };
// theme.typography.h5 = {
//   fontSize: '1rem',
//   [theme.breakpoints.up('md')]: {
//     fontSize: '2rem'
//   }
// };
// theme.typography.h6 = {
//   fontSize: '0.8rem',
//   [theme.breakpoints.up('md')]: {
//     fontSize: '1.5rem'
//   }
// };

const App = () => {
  const onKeycloakEvent = event => {
    if (event === 'onAuthSuccess') {
      onAuthSuccess();
    }
  };

  return (
    <DatePickedProvider>
      <Provider {...stores}>
        <KeycloakProvider
          keycloak={keycloak}
          initConfig={keycloakProviderInitConfig}
          onEvent={onKeycloakEvent}
        >
          <MuiThemeProvider theme={theme}>
            <EndingDialogProvider>
              <EndingDialog />
              <LoadingProvider>
                <CustomSnackbarProvider>
                  <LayoutProvider>
                    <MainApp />
                  </LayoutProvider>
                </CustomSnackbarProvider>
              </LoadingProvider>
            </EndingDialogProvider>
          </MuiThemeProvider>
        </KeycloakProvider>
      </Provider>
    </DatePickedProvider>
  );
};
export default App;
